import React, {Component} from 'react';

import {globalDocument} from '../../../../../libs/shared/helpers/src/browser/browserHelpers';
import {KeyboardActionsEnum} from '../../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {KeyboardShortcuts} from '../../../../../libs/shared/ui/src/components/keyboard/keyboardShortcuts';
import {TraceDropdownContainer} from './traceDropdownContainer';

/*
 * Component.
 */

interface TraceBrowserState {
  isOpen: boolean;
}

export class TraceBrowser extends Component<{}, TraceBrowserState> {
  constructor(props: {}) {
    super(props);
    this.state = {isOpen: false};
  }

  /*
   * Event handlers.
   */

  private readonly toggleIsOpen = () => {
    this.setState(({isOpen}) => ({isOpen: !isOpen}));
  };

  /*
   * Render.
   */

  render() {
    const keyHandlers = {[KeyboardActionsEnum.TRACE]: this.toggleIsOpen};
    return <KeyboardShortcuts handlers={keyHandlers}>{this.maybeRenderDropdown()}</KeyboardShortcuts>;
  }

  private maybeRenderDropdown() {
    if (!this.state.isOpen) {
      return null;
    }

    return (
      <TraceDropdownContainer
        anchor={() => globalDocument.body.getBoundingClientRect()}
        placement="top-start"
        onRequestClose={this.toggleIsOpen}
      />
    );
  }
}
